import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    FlartTakeOverStatus: 'idle',
    FlartTakeOverError: undefined as any,

    flartTakeOverList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const FlartTakeOver = createAsyncThunk('flartTakeOverSlice/FlartTakeOver', async ({ flartTakeOver }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/FlartMenu_TakeOver/`,
        prepareData(flartTakeOver),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { FlartTakeOverStatus } = getState().flartTakeOverSlice
        return FlartTakeOverStatus !== 'pending'
    }
})

const FlartTakeOverSlice = createSlice({
    name: 'flartTakeOverSlice',
    initialState,
    reducers: {
        resetFlartTakeOverError: (state) => {
            state.FlartTakeOverError = undefined
        },
        removeFromFlartTakeOverListById: (state, action) => {
            state.flartTakeOverList = state.flartTakeOverList.filter((x: any) => x.None !== action.payload)
        },
        removeFromFlartTakeOverListByIds: (state, action) => {
            state.flartTakeOverList = state.flartTakeOverList.filter((x: any) => action.payload.indexOf(x.None) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flartTakeOverList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.FlartTakeOverStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flartTakeOverList = []
            state.FlartTakeOverStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(FlartTakeOver.pending, (state) => {
            state.FlartTakeOverStatus = 'pending'
            state.FlartTakeOverError = undefined
        })
        builder.addCase(FlartTakeOver.fulfilled, (state, action) => {
            state.FlartTakeOverStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flartTakeOverList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flartTakeOverList.push(newItem) }
                else { state.flartTakeOverList[i] = { ...state.flartTakeOverList[i], ...newItem } }
            }
        })
        builder.addCase(FlartTakeOver.rejected, (state, action) => {
            state.FlartTakeOverStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.FlartTakeOverError = action.error.message
            } else {
                state.FlartTakeOverError = action.payload
            }
        })

    }
})

export const {
    resetFlartTakeOverError,
    removeFromFlartTakeOverListById,
    removeFromFlartTakeOverListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlartTakeOverSlice.actions
export default FlartTakeOverSlice.reducer
